import { Spinner } from '@/components/ui/spinner';

interface DomainCheckerProps {
  email: string;
}

export function DomainChecker({ email }: DomainCheckerProps) {
  return (
    <div className="py-8 text-center">
      <Spinner size={24} className="mx-auto mb-4 text-black" />
      <p className="mb-2 text-neutral-600">Checking {email}</p>
    </div>
  );
}
